import {
  Box,
  CardMedia,
  Paper,
  Typography
} from "@material-ui/core";
import React from "react";
import { useLocation } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

const ThankYouPage = () => {
  const classes = useStyles();
  const location = useLocation();

  const _token = location?.state?.tokenExp || false;
  const _invalidUrl = location?.state?.invalidUrl || false;

  return (
    <Box className={classes.container} >
      <Box style={{ backgroundColor: "#F0EFF6", minHeight: "100vh" }}>
        <Box className={classes.mainBody}>
          {!_token && (
            <Paper className={classes.paper}>
              <Typography className={classes.title}>
                成功提交表格！
              </Typography>
              <CardMedia
                component="img"
                image={require("../icons/thankYou.png")}
                alt=""
                className={classes.media}
              />
            </Paper>
          )}
          {!!_token && (
            <Paper className={classes.paper}>
              <CardMedia
                component="img"
                image={require("../icons/tokenExp.png")}
                alt=""
                className={classes.mediaToken}
              />
              <Typography
                className={classes.title}
                style={{ color: "#454C96" }}
              >
                此連結{ _invalidUrl ? "無效" : "已經失效"}
              </Typography>
            </Paper>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ThankYouPage;

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#454C96",
    fontSize: "36px",
    fontFamily: "Noto Sans",
    fontWeight: 700,
    wordWrap: "break-word",
    textAlign: "center",
    paddingBottom: "35px",
    [`@media (max-width: 430px)`]: {
      fontSize: "24px",
    },
  },
  titleContent: {
    fontWeight: 400,
    justifyContent: "center",
    padding: "1.5rem 0px",
  },
  container: {
    // display: "flex",
    height: "100vh",
    borderRadius: "10rem",
  },
  mainBody: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "100px 5rem",
    [`@media (max-width: 1150px)`]: {
      padding: "100px 1rem",
    },
    [`@media (max-width: 430px)`]: {
      padding: "150px 1rem",
    },
  },

  media: {
    width: "300px",
    objectFit: "contain",
    cursor: "pointer",
    margin: "0 auto",
    [`@media (max-width: 429px)`]: {
      width: "250px",
    },
  },

  mediaToken: {
    width: "40px",
    height: "100px",
    margin: "0 auto",
    objectFit: "contain",
    cursor: "pointer",
  },
  paper: {
    width: "100%",
    maxWidth: "1080px",
    padding: "200px 0",
    borderRadius: "32px",
    [`@media (max-width: 430px)`]: {
      padding: "100px 0",
    },
  },
}));
